export const DeleteCard = ({
  strokeColor = "var(--color-red)",
  ...props
}: any) => (
  <svg width="34" height="34" viewBox="0 0 34 34" fill="none" {...props}>
    <circle cx="17" cy="17" r="17" fill="var(--color-bg-primary)" />
    <path
      d="M24.5001 12.6074C24.4834 12.6074 24.4584 12.6074 24.4334 12.6074C20.0251 12.1658 15.6251 11.9991 11.2667 12.4408L9.56672 12.6074C9.21672 12.6408 8.90839 12.3908 8.87505 12.0408C8.84172 11.6908 9.09172 11.3908 9.43339 11.3574L11.1334 11.1908C15.5667 10.7408 20.0584 10.9158 24.5584 11.3574C24.9001 11.3908 25.1501 11.6991 25.1167 12.0408C25.0917 12.3658 24.8167 12.6074 24.5001 12.6074Z"
      fill={strokeColor}
    />
    <path
      d="M14.0831 11.766C14.0498 11.766 14.0165 11.766 13.9748 11.7577C13.6415 11.6993 13.4081 11.3743 13.4665 11.041L13.6498 9.94935C13.7831 9.14935 13.9665 8.04102 15.9081 8.04102H18.0915C20.0415 8.04102 20.2248 9.19102 20.3498 9.95768L20.5331 11.041C20.5915 11.3827 20.3581 11.7077 20.0248 11.7577C19.6831 11.816 19.3581 11.5827 19.3081 11.2493L19.1248 10.166C19.0081 9.44102 18.9831 9.29935 18.0998 9.29935H15.9165C15.0331 9.29935 15.0165 9.41602 14.8915 10.1577L14.6998 11.241C14.6498 11.5493 14.3831 11.766 14.0831 11.766Z"
      fill={strokeColor}
    />
    <path
      d="M19.675 25.9577H14.325C11.4167 25.9577 11.3 24.3493 11.2083 23.0493L10.6667 14.6577C10.6417 14.316 10.9083 14.016 11.25 13.991C11.6 13.9743 11.8917 14.2327 11.9167 14.5743L12.4583 22.966C12.55 24.2327 12.5833 24.7077 14.325 24.7077H19.675C21.425 24.7077 21.4583 24.2327 21.5417 22.966L22.0833 14.5743C22.1083 14.2327 22.4083 13.9743 22.75 13.991C23.0917 14.016 23.3583 14.3077 23.3333 14.6577L22.7917 23.0493C22.7 24.3493 22.5833 25.9577 19.675 25.9577Z"
      fill={strokeColor}
    />
    <path
      d="M18.3834 21.375H15.6084C15.2667 21.375 14.9834 21.0917 14.9834 20.75C14.9834 20.4083 15.2667 20.125 15.6084 20.125H18.3834C18.7251 20.125 19.0084 20.4083 19.0084 20.75C19.0084 21.0917 18.7251 21.375 18.3834 21.375Z"
      fill={strokeColor}
    />
    <path
      d="M19.0832 18.041H14.9165C14.5748 18.041 14.2915 17.7577 14.2915 17.416C14.2915 17.0743 14.5748 16.791 14.9165 16.791H19.0832C19.4248 16.791 19.7082 17.0743 19.7082 17.416C19.7082 17.7577 19.4248 18.041 19.0832 18.041Z"
      fill={strokeColor}
    />
  </svg>
);
